import React from 'react'
import SelectField from '../SelectField'
import StartLabelField from './StartLabelField'
import type { SelectFieldProps } from '../SelectField'

type Props = SelectFieldProps & {
    label: string
}

/**
 *  Must be in the grid container to display properly
 * */
export const StartLabelSelectField: React.VFC<Props> = ({ name, label, ...fieldProps }: Props) => {
    return (
        <StartLabelField name={name} label={label}>
            <SelectField name={name} {...fieldProps} />
        </StartLabelField>
    )
}

export default StartLabelSelectField
export type { Props as StartLabelSelectFieldProps }
